import React from "react"
import Skeleton from "react-loading-skeleton"
import DynamicSkeleton from "../../components/DynamicSkeleton"

const columnConfig = {
  ID: { content: <Skeleton height="20px" width="70px" />, center: true },
  "Station Detail": {
    content: <Skeleton height="64px" width="350px" />,
    center: false,
  },
  Consumption: {
    content: <Skeleton height="20px" width="60px" />,
    center: true,
  },
  Bookings: { content: <Skeleton height="20px" width="60px" />, center: true },
  Revenue: { content: <Skeleton height="20px" width="60px" />, center: true },
}

const Section3Skeleton = ({ infiniteScroll, rows = 5 }) => {
  return (
    <DynamicSkeleton
      rows={rows}
      columnConfig={columnConfig}
      infiniteScroll={infiniteScroll}
    />
  )
}

export default Section3Skeleton
